'use strict';

(function () {
  'use strict';

  angular.module('msActivities').provider('activityRouter', activityRouterProvider);
  /* @ngInject */
  function activityRouterProvider() {
    var provider = this;
    provider.buildRoutes = _buildRoutes;
    provider.$get = ['$state', '$log', 'trainSvc', activityRouterFactory];

    function activityRouterFactory($state, $log, trainSvc) {
      var factory = this;
      factory.router = {
        navigateDefault: _navigateDefault,
        navigateActivity: _navigateActivity,
        navigateIntro: _navigateIntro,
        navigateProgram: _navigateProgram,
        navigateInspiration: _navigateInspiration,
        nextSection: _navigateSection,
        completeTrain: _navigateCompleteTrain,
        giveFeedback: _navigateFeedback,
        showHistory: _navigateHistoryRespose,
        goToState: _goToState,
        buildReturnPath: _setCurrentAsDest,
        createTrain: _createTrain,
        startTrain: _startTrain,
        navigateTrain: _navTrain,
        skipActivity: _skip,
        skipToActivity: _skipTo
      };
      return factory.router;
      /**
       * Set the current location as the destination at the end of the train.
       * If we aren't currently in a state, this will send them to the homepage
       */
      function _setCurrentAsDest() {
        var dest,
            currentRoute = $state.current.name;
        if (currentRoute) {
          dest = {
            navigateFn: function navigateFn(args) {
              _goToState(currentRoute, args);
            },
            params: $state.params
          };
        } else {
          dest = {
            navigateFn: function navigateFn(args) {
              _navigateDefault(args);
            },
            params: {}
          };
        }
        return dest;
      }

      function _createTrain(activities, dest, noNav) {
        return trainSvc.createTrain(factory.router, activities, dest || _setCurrentAsDest(), noNav);
      }

      function _startTrain() {
        return trainSvc.startTrain(factory.router);
      }

      function _navTrain() {
        return trainSvc.navTrain(factory.router);
      }

      function _skip(activity, hide, reason) {
        return trainSvc.skip(activity, hide, reason, factory.router);
      }

      function _skipTo(activity) {
        return trainSvc.skipTo(activity, factory.router);
      }

      function _goToState(name, args) {
        $state.go(name, args);
      }

      function _navigateDefault(args) {
        var route = provider.baseRoutePrefix ? provider.baseRoutePrefix + provider.defaultRoute : provider.defaultRoute;
        _goToState(route, args);
      }

      function _navigateActivity(args) {
        var route = provider.baseRoutePrefix + '.activity';
        _goToState(route, args);
      }

      function _navigateIntro(args) {
        var route = provider.baseRoutePrefix + '.activity.intro';
        _goToState(route, args);
      }

      function _navigateSection(args) {
        var route = provider.baseRoutePrefix + '.activity.section';
        _goToState(route, args);
      }

      function _navigateProgram(args) {
        var route = provider.baseRoutePrefix + '.program';
        _goToState(route, args);
      }

      function _navigateFeedback(args) {
        var route = provider.baseRoutePrefix + '.activity.feedback';
        _goToState(route, args);
      }

      function _navigateInspiration(args) {
        var route = provider.baseRoutePrefix + '.inspiration';
        _goToState(route, args);
      }

      function _navigateCompleteTrain(args) {
        var route = provider.baseRoutePrefix + '.complete';
        _goToState(route, args);
      }

      function _navigateHistoryRespose(args) {
        var route = provider.baseRoutePrefix + '.history.response';
        _goToState(route, args);
      }
    }

    /**
     * Configure the provider context and build the route defns
     * @param  {Object} baseRoutePrefix the base prefix for all routes in this context
     * @param  {boolean} defaultRoute   the fully-qualified default route to fall back to - generally a homepage
     * @return The built routes as an array
     */
    function _buildRoutes(baseRoutePrefix, defaultRoute) {
      //set provider level values
      provider.baseRoutePrefix = baseRoutePrefix;
      provider.defaultRoute = defaultRoute;
      //build the routes
      var base = _buildBaseRoute(baseRoutePrefix);
      var intro = _buildIntroRoute(baseRoutePrefix);
      var section = _buildSectionRoute(baseRoutePrefix);
      var feedback = _buildFeedbackRoute(baseRoutePrefix);
      var inspiration = _buildInspirationRoute(baseRoutePrefix);
      var program = _buildProgramRoute(baseRoutePrefix);
      var trainComplete = _buildTrainCompleteRoute(baseRoutePrefix);
      var viewHistoryResponse = _buildViewHistoryRoute(baseRoutePrefix);
      //return an array of the route defns for wiring in consumer context
      return [base, intro, section, feedback, inspiration, program, trainComplete, viewHistoryResponse];
    }
  }

  function _buildBaseRoute(baseRoutePrefix) {
    return {
      name: baseRoutePrefix + '.activity',
      url: 'activity/:url/?version',
      abstract: true,
      default: '.intro',
      template: '<div ui-view></div>',
      controller: 'ActivityCtrl',
      controllerAs: 'activityVm',
      resolve: {
        activity: ['$stateParams', '$log', 'activitySvc', 'trainSvc', 'languageSvc', 'activityRouter', 'errorRouter', function ($stateParams, $log, activitySvc, trainSvc, languageSvc, activityRouter, errorRouter) {
          if ($stateParams.url === "") {
            return [];
          } else {
            return activitySvc.getActivity($stateParams.url, $stateParams.version, languageSvc.getLanguage()).then(function (dat) {
              if (!trainSvc.containsActivity($stateParams.url)) {
                activityRouter.createTrain(dat, {
                  navigateFn: function navigateFn(args) {
                    return activityRouter.navigateDefault(args);
                  },
                  params: {}
                }, true);
              }
              return dat;
            }, function (resp) {
              $log.debug(resp);
              errorRouter.navigateError({
                message: 'The activity <strong>' + $stateParams.url + '</strong> you are looking for is not available right now.' + '<br/><br/>' + 'Try to find another one <b><a href="/v/browse">here</a></b>',
                errorCode: resp.status,
                contact: false
              });
            });
          }
        }],
        responses: ['$stateParams', 'msAuth', 'activityResponseSvc', function ($stateParams, msAuth, activityResponseSvc) {
          if (msAuth.isLoggedIn()) {
            return activityResponseSvc.getResponses($stateParams.url).then(function (data) {
              return data;
            });
          } else {
            return null;
          }
        }]
      },
      data: {
        pageTitle: 'pageTitles.activity'
      },
      params: {
        focus: null
      }
    };
  }

  function _buildIntroRoute(baseRoutePrefix) {
    return {
      name: baseRoutePrefix + '.activity.intro',
      url: 'intro',
      templateUrl: 'activities/pages/intro.html',
      controller: 'ActivityIntroCtrl',
      controllerAs: 'introVm',
      data: {
        pageTitle: 'pageTitles.activity'
      }
    };
  }

  function _buildSectionRoute(baseRoutePrefix) {
    return {
      name: baseRoutePrefix + '.activity.section',
      url: 'detail/:section',
      templateUrl: 'activities/pages/detail.html',
      controller: 'ActivitySectionCtrl',
      controllerAs: 'vm',
      data: {
        pageTitle: 'pageTitles.activity'
      },
      resolve: {
        section: ['activity', '$stateParams', 'NotifyingSvc', function (activity, $stateParams, NotifyingSvc) {
          var sectionUuid = $stateParams.section || activity.firstSection;

          NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.PAGE_TITLE, {
            pageTitle: activity.title
          });

          return activity.sections.filter(function (section) {
            return section.uuid === sectionUuid;
          })[0];
        }]
      },
      params: {
        section: {
          squash: true,
          value: ''
        }
      }
    };
  }

  function _buildFeedbackRoute(baseRoutePrefix) {
    return {
      name: baseRoutePrefix + '.activity.feedback',
      url: 'feedback',
      templateUrl: 'activities/pages/feedback.html',
      controller: 'ActivityFeedbackCtrl',
      controllerAs: 'vm',
      data: {
        pageTitle: 'pageTitles.activity'
      }
    };
  }

  function _buildInspirationRoute(baseRoutePrefix) {
    return {
      name: baseRoutePrefix + '.inspiration',
      url: 'inspiration/:url',
      templateUrl: 'activities/pages/inspiration.html',
      controller: 'ActivityInspirationCtrl',
      controllerAs: 'vm',
      resolve: {
        inspiration: ['$stateParams', 'inspirationSvc', '$log', 'errorRouter', function ($stateParams, inspirationSvc, $log, errorRouter) {
          return inspirationSvc.get($stateParams.url).then(function (data) {
            return data;
          }, function (resp) {
            $log.debug(resp);
            errorRouter.navigateError({
              message: 'The Inspiration <strong>' + $stateParams.url + '</strong> you are looking for is not available right now.' + '<br/><br/>' + 'Try to find another one <b><a href="/v/browse">here</a></b>',
              errorCode: resp.status,
              contact: false
            });
          });
        }]
      }
    };
  }

  function _buildProgramRoute(baseRoutePrefix) {
    return {
      name: baseRoutePrefix + '.program',
      url: 'program/:id',
      templateUrl: 'activities/pages/program.html',
      controller: 'ActivityProgramCtrl',
      controllerAs: 'vm',
      resolve: {
        program: ['$stateParams', 'seriesSvc', 'errorRouter', '$log', function ($stateParams, seriesSvc, errorRouter, $log) {
          return seriesSvc.getProgram($stateParams.id).then(function (data) {
            return data;
          }, function (resp) {
            $log.debug(resp);
            errorRouter.navigateError({
              message: 'The program <strong>' + $stateParams.url + '</strong> you are looking for is not available right now.' + '<br/><br/>' + 'Try to find another one <b><a href="/v/browse">here</a></b>',
              errorCode: resp.status,
              contact: false
            });
          });
        }]
      },
      data: {
        pageTitle: 'pageTitles.program'
      }
    };
  }

  function _buildTrainCompleteRoute(baseRoutePrefix) {
    return {
      name: baseRoutePrefix + '.complete',
      url: 'complete',
      templateUrl: 'activities/pages/complete.html',
      controller: 'TrainCompleteCtrl',
      controllerAs: 'vm',
      data: {
        pageTitle: 'pageTitles.nextUp'
      }
    };
  }

  function _buildViewHistoryRoute(baseRoutePrefix) {
    return {
      name: baseRoutePrefix + '.history.response',
      url: '/responses/:response',
      templateUrl: 'vnext/pages/history/response.html',
      controller: 'ActivityUserResponseCtrl',
      controllerAs: 'activityVm',
      resolve: {
        responseId: ['$stateParams', function ($stateParams) {
          return $stateParams.response;
        }],
        activityResponse: ['$stateParams', 'activitySvc', 'httpSvc', function ($stateParams, activitySvc, httpSvc) {
          return httpSvc.get('/apiproxy/user/activities/responses/' + $stateParams.response);
        }],
        status: ['$stateParams', 'activitySvc', function ($stateParams, activitySvc) {
          return activitySvc.getActivityResponseSharedStatus($stateParams.response);
        }]
      }
    };
  }
})();